import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagesOverviewComponent } from './pages-overview.component';
import { PagesOverviewRoutingModule } from './pages-overview-routing.module';
import { ExportModule } from '@client/app/modules/export/export.module';
import { TranslateModule } from '@client/app/modules/translate.module';
import { ComponentsModule } from '@client/app/components/components.module';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [
        PagesOverviewComponent,
    ],
    imports: [
        ExportModule,
        TranslateModule,
        ComponentsModule,
        UpgradePipeModule,
        CommonModule,
        PagesOverviewRoutingModule,
    ],
})
export class PagesOverviewModule { }
